var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-2",staticStyle:{"width":"232px"}},[_c('el-date-picker',{attrs:{"type":"daterange","name":_vm.name,"start-placeholder":"siden","end-placeholder":"før","value-format":"yyyy-MM-dd"},model:{value:(_vm.defaultValue),callback:function ($$v) {_vm.defaultValue=$$v},expression:"defaultValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }